import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=5b00229d&scoped=true"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"
import style0 from "./Product.vue?vue&type=style&index=0&id=5b00229d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b00229d",
  null
  
)

export default component.exports